import React, { Fragment, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import {
  getAllCategories,
  getAllNullParentCategories,
} from "../../../../services/categories";
import CatDropItem from "./CatDropItem";
import classes from "./CatDropList.module.css";
import LoadingSpinner from "../../../../components/ui/loadingSpinner/LoadingSpinner";
import EmptyState from "../../../../components/common/EmptyState";

const CatDropList = () => {
  const {
    sendRequest,
    status,
    data: categoriesData,
    error,
  } = useHttp(getAllNullParentCategories, true);

  useEffect(() => {
    sendRequest();
  }, [sendRequest]);

  let content;

  if (status === "completed" && categoriesData && categoriesData.length > 0) {
    content = <CatDropItem fetchData={categoriesData} />;
  }
  if (
    status === "completed" &&
    (!categoriesData || categoriesData.length === 0)
  ) {
    content = <EmptyState
          title="No category Available"
          message="This particular category route does not contain any matching products right now. Look at our trending selection below!"
          showButton={false}
        />;
  }
  if (error) {
    content = <EmptyState showButton={false} />;
  }
  if (status === "pending") {
    content =  <div className="centered">
        <LoadingSpinner />
      </div>;
  }
  return <Fragment>{content}</Fragment>;
};

export default CatDropList;
